import React from 'react';

import classNames from 'classnames';

import GridIcon from 'Assets/icons/grid-header.svg';
import ListIcon from 'Assets/icons/list.svg';

export const VIEW_CARDS = 'cards';
export const VIEW_LIST = 'list';

const OPTIONS = [
    { id: VIEW_CARDS, label: $t('Cards'), Icon: GridIcon },
    { id: VIEW_LIST, label: $t('List'), Icon: ListIcon },
];

// Segmented Cards/List control, styled as the app's other segmented toggles.
export default function CardsListToggle({ value, onChange }) {
    return (
        <div className="tw-inline-flex tw-rounded-full tw-border-2 tw-border-blue tw-overflow-hidden" role="group">
            {OPTIONS.map(({ id, label, Icon }) => (
                <button
                    key={id}
                    type="button"
                    aria-pressed={value === id}
                    onClick={() => onChange(id)}
                    className={classNames('tw-inline-flex tw-items-center tw-gap-x-2 tw-px-4 tw-py-1 tw-text-sm tw-font-medium tw-transition-colors', {
                        'tw-bg-blue tw-text-white': value === id,
                        'tw-bg-white tw-text-blue': value !== id,
                    })}
                >
                    <Icon className="tw-w-3.5 tw-h-3.5" />
                    {label}
                </button>
            ))}
        </div>
    );
}
